'use client';
import type { FunctionComponent } from 'react';

import { Toast as FlowbiteToast } from 'flowbite-react';

import { AbbMarkCircle } from '@/assets/icons/components/abb-check-mark-circle';
import { AbbClose } from '@/assets/icons/components/abb-close';
import { AbbErrorCircle } from '@/assets/icons/components/abb-error-circle';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { useTheme } from '@/modules/utils/custom-hooks/use-theme';

import type { ToastProps } from './types';

export const Toast: FunctionComponent<ToastProps> = ({ message, variant = 'success', closeButton = false, visible }) => {
  const { setIsToastVisible } = useAppContext();
  const { isDarkTheme } = useTheme();

  const variants = {
    error: {
      bg: 'bg-[#F5E7E6]',
      text: 'text-brand',
      icon: <AbbErrorCircle fill='#E6000E' />
    },
    success: {
      bg: 'bg-[#E5EFEC]',
      icon: <AbbMarkCircle fill='#21A67A' />
    },
    info: {
      bg: 'bg-[#E5F2FF]',
      icon: <AbbMarkCircle fill='#3366FF' />
    },
    warning: {
      bg: 'bg-[#FFF4E5]',
      icon: <AbbMarkCircle fill='#FF8C00' />
    }
  };

  return (
    <FlowbiteToast
      className={`fixed top-14 left-1/2 p-4 w-auto z-[60] transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-1000 ${visible ? 'translate-y-0' : '-translate-y-[1000px]'} ${variants[variant].bg}`}
    >
      <div className='flex justify-start items-center gap-3 '>
        {variants[variant].icon}
        <p className='text-sm font-medium text-dark dark:text-n700_text_dark_mode'>{message}</p>
        {closeButton && (
          <AbbClose
            size={24}
            fill={isDarkTheme ? '#f1f1f1' : '#666666'}
            className='!cursor-pointer'
            onClick={() => setIsToastVisible(false)}
          />
        )}
      </div>
    </FlowbiteToast>
  );
};
